import { useEffect, useState } from 'react';
import styles from './ImageSlider.module.css';
import { HOME_PHOTO_INTERVAL } from 'config/constants';
import classNames from 'classnames';
import { PhotoData } from 'types/PhotoData';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { ThemeBanner } from 'components/ThemeBanner/ThemeBanner';
import { readAppliedPlayerTheme, usesLogoTheme } from 'lib/playerTheme';

interface Props {
  photos: PhotoData[];
}

export const ImageSlider = ({ photos }: Props) => {
  const [photoIndex, setPhotoIndex] = useState<number>(0);
  // The promo JPEGs are tottalo-branded (its blue display type on a blue/green
  // photo), so alt themes get the vector equivalents instead.
  const useThemeArt = !usesLogoTheme(readAppliedPlayerTheme());

  useEffect(() => {
    const interval = setInterval(
      () => setPhotoIndex((photoIndex + 1) % photos.length),
      HOME_PHOTO_INTERVAL
    );

    return () => clearInterval(interval);
  }, [photoIndex]);

  return (
    <div className={styles.wrapper}>
      {useThemeArt && photos[photoIndex].bannerKind ? (
        <ThemeBanner kind={photos[photoIndex].bannerKind!} />
      ) : (
        <img src={photos[photoIndex].imagePath} alt={`${photoIndex + 1}`} />
      )}
      <div className={styles.bulletsWrapper}>
        {photos.map((_, index) => (
          <div
            key={index}
            className={classNames(
              styles.bullet,
              photoIndex === index
                ? styles.bulletSelected
                : styles.bulletRegular
            )}
            onClick={() => setPhotoIndex(index)}
          ></div>
        ))}
      </div>
      {photos[photoIndex].button && (
        <div className={styles.buttonWrapper} key={photoIndex}>
          <ButtonLink
            href={photos[photoIndex].button!.url}
            title={photos[photoIndex].button!.buttonText}
          />
        </div>
      )}
    </div>
  );
};
